import {StableLinksWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/stableLinksWorkspaceCapability/domain/StableLinksWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type StableLinksWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.stableLinks> & {
    fixedUdoTemplates: {
        [StableLinksWorkspaceCapabilityUdoTemplateKey.stableLink]: {
            udoAdditionalColumnIds: {
                description: Uuid;
                destinationUrl: Uuid;
                displayName: Uuid;
                status: Uuid;
            };
        };
    };
};

export const stableLinksWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [StableLinksWorkspaceCapabilityUdoTemplateKey.stableLink]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({
                status: uuidZodValidator,
                description: uuidZodValidator,
                destinationUrl: uuidZodValidator,
                displayName: uuidZodValidator,
            }),
            udoTemplateId: uuidZodValidator,
        }),
    }),
}) satisfies zod.ZodType<StableLinksWorkspaceCapabilityUdoBindings>;
